/**
 * Scrolls the product media zoom drawer to the clicked media item before the
 * drawer's open animation finishes. Works for both the mobile in-cell trigger
 * and each desktop thumbnail in <flickity-controls>.
 *
 * Triggers carry `aria-controls="ProductMediaZoom-<section-id>"` and
 * `data-media-id="<media-id>"`; each item in the drawer carries the matching
 * `data-media-id`. We use `useCapture: true` so the scroll position is set
 * before the toggle-button click handler opens the drawer.
 *
 * @param {MouseEvent} event
 * @returns {void}
 */
const onTriggerClick = event => {
  const trigger = event.target.closest('[aria-controls^="ProductMediaZoom-"][data-media-id]');
  if (!trigger) return;
  const drawer = document.getElementById(trigger.getAttribute("aria-controls"));
  if (!drawer) return;
  const content = drawer.querySelector(".product-media-zoom__content");
  if (!content) return;
  const target = drawer.querySelector(`.product-media-zoom__item[data-media-id="${trigger.getAttribute("data-media-id")}"]`);
  if (target) content.scrollTop = target.offsetTop;
};
document.addEventListener("click", onTriggerClick, true);
